// extracted by mini-css-extract-plugin
module.exports = {"tableContainer":"PredictiveTable_tableContainer__jTzQa","tableText":"PredictiveTable_tableText__2bjVa"};